import { render } from "./GamesRules.vue?vue&type=template&id=41797dd5&scoped=true"
import script from "./GamesRules.vue?vue&type=script&lang=js"
export * from "./GamesRules.vue?vue&type=script&lang=js"

import "./GamesRules.vue?vue&type=style&index=0&id=41797dd5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41797dd5"]])

export default __exports__